import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Globe } from 'lucide-react';
import './Registrationtype.css';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const EditRegistrationtype = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({
    name: "",
    amount: ""  // Added amount field
  });

  useEffect(() => {
    const fetchRegistrationtype = async () => {
      try {
        const response = await axios.get(`${url}/api/registrationtype/${id}`);
        setData({
          name: response.data.data.name,
          code: response.data.data.code || "",
          amount: response.data.data.amount || "" // Fetch existing amount
        });
      } catch (error) {
        toast.error("Failed to load Registration Type data");
        navigate('/ViewRegistrationtype');
      }
    };

    fetchRegistrationtype();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await axios.put(
        `${url}/api/registrationtype/${id}`,
        data
      );

      if (response.data.success) {
        toast.success("Registration Type updated successfully!");
        navigate('/ViewRegistrationtype');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update Registration Type");
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="form-wrapper">
      <div className="country-form-container">
        <h2 className="form-title">
          <Globe size={20} className="inline mr-2" /> Edit Registration Type
        </h2>
        
        <form className="country-form" onSubmit={handleSubmit}>
          <div className="form-field filled">
            <input
              type="text"
              name="name"
              value={data.name}
              onChange={handleChange}
              required
            />
            <label>Registration Type</label>
          </div>

          <div className="form-field filled">
            <input
              type="number"
              name="amount"
              value={data.amount}
              onChange={handleChange}
              required
            />
            <label>Amount</label>
          </div>

          <div className="button-group">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => navigate('/ViewRegistrationtype')}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="submit-btn" 
              disabled={submitting}
            >
              {submitting ? "Updating..." : "Update Registration Type"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditRegistrationtype;
